import React from "react";
import { Link } from "react-router-dom";
import "../styles/WaterQualityAnalysis.css";

function WaterQualityAnalysis() {
  return (
    <div className="water-quality">
      <h1>水质分析</h1>
      <div className="options">
        <Link to="/eco-water-report">生成水质分析报告</Link>
        <Link to="/modify-water-report">修改水质分析报告</Link>
        <Link to="/update-concentration">查询/更新标液浓度</Link>
      </div>
    </div>
  );
}

export default WaterQualityAnalysis;
